import type { Novidade } from './tipos';

/** Fase 2 (W22, K8): avisos novos no sino, antecedência dos avisos e exceções do membro em Admin > Usuários. */
export const novidadeAvisos: Novidade = {
  id: '2026-10-05-avisos',
  publicada_em: '2026-10-05',
  tipo: 'melhoria',
  modulo: null,
  permissao: null,
  textos: {
    pt: {
      titulo: 'Mais avisos no sino',
      resumo: 'Exportação pronta, pedido atrasado, folha fechada, conector com erro, convite aceito, usuário desativado, contrato e fatura perto do fim.',
      passos: [
        'Os avisos chegam no sino só para quem tem acesso ao registro e à empresa dele; clique para abrir o registro.',
        'Em Contas a receber e a pagar > Cobranças, ajuste quantos dias antes avisar de contas a pagar, faturas e contratos perto do fim (0 desliga).',
        'Em Admin > Usuários e papéis, abra o membro e ligue ou desligue avisos só para ele, por cima do padrão do papel.',
      ],
    },
    en: {
      titulo: 'More notices in the bell',
      resumo: 'Export ready, overdue order, payroll closed, connector error, invitation accepted, user deactivated, contract and invoice coming due.',
      passos: [
        'Notices reach only people with access to the record and its company; click to open the record.',
        'In Receivables and payables > Collections, set how many days before to notify about bills, invoices and contracts ending (0 turns it off).',
        'In Admin > Users and roles, open the member and turn notices on or off just for them, over the role default.',
      ],
    },
    es: {
      titulo: 'Más avisos en la campana',
      resumo: 'Exportación lista, pedido atrasado, nómina cerrada, conector con error, invitación aceptada, usuario desactivado, contrato y factura.',
      passos: [
        'Los avisos llegan solo a quien tiene acceso al registro y a su empresa; haz clic para abrir el registro.',
        'En Cuentas por cobrar y por pagar > Cobranzas, ajusta cuántos días antes avisar de cuentas por pagar, facturas y contratos por terminar (0 desactiva).',
        'En Admin > Usuarios y roles, abre el miembro y activa o desactiva avisos solo para él, por encima del valor del rol.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-avisos/central.webp', '/novidades/2026-10-05-avisos/antecedencia.webp', '/novidades/2026-10-05-avisos/excecoes.webp'],
  treinamento: { curso: 'novidades' },
  rota: '/conta/notificacoes',
};
